
/* injects from baggage-loader */
require('./style.scss');

import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import _ from "lodash";

import { RegisterMode, ClearCardRegistered } from "../../../actions/terminal";
import Zergling from '../../../helpers/zergling';
import { ClosePopup, OpenPopup } from "../../../actions/ui";
import { t } from "../../../helpers/translator";
import KeyboardInput from "../InputKeyboard";
import { getSwarmSetRfidPinCodeRequest } from "../../../helpers/terminalRequests/rfid";
import { Logout } from "../../../actions/login";

const DmsSetPinCode = ({ dispatch, isAdminLoggedIn, isCardRegistered, popupParams, loginPin }) => {
    const [form, setForm] = useState({
        PinCode: '',
        ConfirmPinCode: '',
        Rfid: popupParams?.rfid,
    });

    const wrongConfirmPin = useMemo(() => form.PinCode && form.ConfirmPinCode && form.PinCode !== form.ConfirmPinCode, [form]);
    const isFormValid = useMemo(() => (
        form.PinCode.length === 4 && form.PinCode !== "0000" &&
        form.ConfirmPinCode && !wrongConfirmPin && _.isInteger(+form.PinCode)
    ), [form, wrongConfirmPin]);

    const submitDisabled = useMemo(() => {        
        if (popupParams?.loggedIn) return !isFormValid || !popupParams?.rfid;

        return (
            !isFormValid ||
            !isCardRegistered ||
            !isAdminLoggedIn ||
            !popupParams?.rfid
        );
    }, [isFormValid, isAdminLoggedIn, isCardRegistered, popupParams]);

    const fieldChange = (name, value) => {
        if (value.length <= 4) {
            setForm({
                ...form,
                [name]: value.trim(),
            })
        }
    };

    const registerPopupForDms = () => {
        dispatch(ClosePopup());
        dispatch(RegisterMode(false));
        dispatch(ClearCardRegistered());
    }

    const submit = async () => {
        if (submitDisabled) return;

        const { ConfirmPinCode, ...params } = form;
        try {
            await Zergling.get(getSwarmSetRfidPinCodeRequest(params), 'betshop_command');

            let messagePopupParams;

            switch (true) {
                case popupParams?.loggedIn:
                    messagePopupParams = {
                        title: t('Change PIN Code'),
                        body: t('PIN code was successfully changed'),
                    };
                    break;
                case popupParams?.reset:
                    messagePopupParams = {
                        title: t('Reset PIN Code'),
                        body: t('PIN code was successfully reseted'),
                    };
                    break;
                default:
                    messagePopupParams = {
                        title: t('Registration'),
                        body: t('You have successfully registered'),
                    };
                    break;
            }

            dispatch(OpenPopup("dmsSuccess", messagePopupParams));
        } catch {
            dispatch(OpenPopup("message", {
                title: t("Error"),
                type: "error",
                body: t("Something went wrong"),
            }));
        }
    }

    return <div>
        <div className="title-popup-page-m-dms">
            <p>{t('Change PIN Code')}</p>
            {!popupParams?.disable && <button className="popup-closed-b" onClick={registerPopupForDms} />}
        </div>
        <div className="ticket-results-view-p">
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('Set new PIN Code')}</p>
                            <div className="single-form-item">
                                <KeyboardInput
                                    numeric
                                    type='password'
                                    value={form.PinCode}
                                    onChange={value => fieldChange('PinCode', value)}
                                />
                            </div>
                            <p className='single-form-item-title'>{t('Repeat new PIN Code')}</p>
                            <div className="single-form-item">
                                <KeyboardInput
                                    numeric
                                    type='password'
                                    value={form.ConfirmPinCode}
                                    onChange={value => fieldChange('ConfirmPinCode', value)}
                                />
                            </div>
                            {wrongConfirmPin && <p>{t("PINs don't match")}</p>}
                            {form.PinCode === "0000" && <p>{t("PIN code cannot be only 0 0 0 0")}</p>}
                        </div>
                    </div>
                </div>
            </form>
            {!isAdminLoggedIn && !popupParams?.loggedIn && <p>{t("Please ask administrator for confirmation")}</p>}
            <div className="separator-box-buttons-m-wrap">
                <div className="separator-box-buttons-m">
                    <button className={`button-view-normal-m ${submitDisabled ? 'trans-m' : ''}`}
                        disabled={submitDisabled}
                        onClick={submit}>
                        {t("Submit")}
                    </button>
                </div>
                <div className="separator-box-buttons-m">
                    <button className="button-view-normal-m trans-m" 
                    onClick={loginPin === "0000" ? () => {
                       dispatch(Logout());
                       dispatch(ClosePopup())
                    }
                     : () => dispatch(ClosePopup())}>
                        {t("Cancel")}
                    </button>
                </div>
            </div>
        </div>
    </div>;
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.isAdminLoggedIn,
            state => state.terminal.isCardRegistered,
            state => state.uiState.popupParams,

        ],
        (isAdminLoggedIn, isCardRegistered, popupParams) => {
            return {
                isAdminLoggedIn,
                isCardRegistered,
                popupParams
            };
        }
    );
};

DmsSetPinCode.propTypes = {
    data: PropTypes.object,
    terminalBalance: PropTypes.number,
    isCardRegistered: PropTypes.object,
    cardRegistered: PropTypes.bool
};

export default connect(mapStateToProps)(DmsSetPinCode);
